import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableRow,
  Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Print from '@material-ui/icons/Print';
import React from 'react';
import ReactToPrint from 'react-to-print';
import ReportHeader from '../share/ReportHeader';
import ButtonObservacao from '../share/ButtonObservacao';

const styles = theme => ({
  root: {
    paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    margin: theme.spacing(2),
  },
  rootNoRegs: {
    paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  button: {
    margin: theme.spacing(1),
  },
  icon: {
    marginRight: theme.spacing(1),
  },
  direita: {
    textAlign: 'right',
    width: '50%',
  },
  centro: {
    textAlign: 'center',
  },
  div: {
    paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    textAlign: 'center',
  },
  typography: {
    paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },
    paddingBottom: theme.spacing(2),
    textAlign: 'center',
  },
  fontReport: {
    fontSize: 10
  }
});

class ComponentToPrint extends React.Component {
  render () {
    const { classes, dividasEmAberto, resumido, dataRef, dataFim, porPeriodo } = this.props;
    let totalSaldoAnteriorDivida = 0;
    let totalValorDividaMes = 0;
    let totalValorPagamentoMes = 0;
    let totalPerdasPorFalecimento = 0;
    let totalPerdasPorPequenoValor = 0;
    let totalDividaEmAberto = 0;
    return (
      <Paper className={classes.root} elevation={0}>
        {porPeriodo === true
        ? <ReportHeader titulo={'Relatório de Dívidas em Aberto - Período: De ' + dataRef + ' a ' + dataFim} />
        : <ReportHeader titulo={'Relatório de Dívidas em Aberto - Mês de Referência: ' + dataRef} />
        }
        {dividasEmAberto !== undefined && dividasEmAberto.length !== 0
          ? !resumido
            ? <Table padding={'default'}>
              <TableHead>
                <TableRow>
                  {porPeriodo && <TableCell className={classes.fontReport} style={{width: '250px'}}>Data</TableCell>}
                  <TableCell className={classes.fontReport} style={{width: '250px'}}>Beneficiario</TableCell>
                  <TableCell className={classes.fontReport} style={{width: '250px'}}>Situação Atual</TableCell>
                  <TableCell className={classes.fontReport} style={{width: '35px'}}>Saldo Anterior da Dívida</TableCell>
                  <TableCell className={classes.fontReport} style={{width: '35px'}}>Valor Dívida Mês</TableCell>
                  <TableCell className={classes.fontReport} style={{width: '35px'}}>Valor Pagamento Mês</TableCell>
                  <TableCell className={classes.fontReport} style={{width: '35px'}}>Perdas por Falecimento</TableCell>
                  <TableCell className={classes.fontReport} style={{width: '35px'}}>Perdas por Pequeno Valor / Prescrição</TableCell>
                  <TableCell className={classes.fontReport} style={{width: '35px'}}>Dívida Em Aberto</TableCell>
                  <TableCell className={classes.fontReport} style={{width: '10px'}}>Obs.</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {dividasEmAberto.map((divida, idx) => {
                  if (divida !== undefined) {
                    totalSaldoAnteriorDivida = totalSaldoAnteriorDivida + divida.saldoAnteriorDivida;
                    totalValorDividaMes = totalValorDividaMes + divida.valorDividaMes;
                    totalValorPagamentoMes = totalValorPagamentoMes + divida.valorPagamentoMes;
                    totalPerdasPorFalecimento = totalPerdasPorFalecimento + divida.perdasPorFalecimento;
                    totalPerdasPorPequenoValor = totalPerdasPorPequenoValor + divida.perdasPorPequenoValor;
                    totalDividaEmAberto = totalDividaEmAberto + divida.dividaEmAberto;
                    return (                      
                      <TableRow key={idx}>          
                        {porPeriodo && <TableCell className={classes.fontReport}>{divida.dataRef}</TableCell>}              
                        <TableCell className={classes.fontReport}>{divida.beneficiario}</TableCell>
                        <TableCell className={classes.fontReport}>{divida.situacaoAtual}</TableCell>
                        <TableCell className={classes.fontReport}>{new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(divida.saldoAnteriorDivida)}</TableCell>
                        <TableCell className={classes.fontReport}>{new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(divida.valorDividaMes)}</TableCell>
                        <TableCell className={classes.fontReport}>{new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(divida.valorPagamentoMes)}</TableCell>
                        <TableCell className={classes.fontReport}>{new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(divida.perdasPorFalecimento)}</TableCell>
                        <TableCell className={classes.fontReport}>{new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(divida.perdasPorPequenoValor)}</TableCell>
                        <TableCell className={classes.fontReport}>{new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(divida.dividaEmAberto)}</TableCell>
                        
                        <TableCell className={classes.fontReport}>
                          <ButtonObservacao
                            title={'Observação'}
                            motivo={divida.txtObservacao}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  }
                })
                }
              </TableBody>
              {!porPeriodo &&<TableFooter>
                <TableRow>                  
                  <TableCell className={classes.fontReport} />
                  <TableCell className={classes.fontReport} >Valores Totais:</TableCell>
                  <TableCell className={classes.fontReport}>{new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(totalSaldoAnteriorDivida)}</TableCell>
                  <TableCell className={classes.fontReport}>{new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(totalValorDividaMes)}</TableCell>
                  <TableCell className={classes.fontReport}>{new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(totalValorPagamentoMes)}</TableCell>
                  <TableCell className={classes.fontReport}>{new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(totalPerdasPorFalecimento)}</TableCell>
                  <TableCell className={classes.fontReport}>{new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(totalPerdasPorPequenoValor)}</TableCell>
                  <TableCell className={classes.fontReport}>{new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(totalDividaEmAberto)}</TableCell>
                  <TableCell className={classes.fontReport}></TableCell>
                </TableRow>
              </TableFooter>}
            </Table>
            : <Table padding={'default'}>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.fontReport} style={{width: '25px'}}>Saldo Anterior da Dívida</TableCell>
                  <TableCell className={classes.fontReport} style={{width: '25px'}}>Valor Dívida Mês</TableCell>
                  <TableCell className={classes.fontReport} style={{width: '25px'}}>Valor Pagamento Mês</TableCell>
                  <TableCell className={classes.fontReport} style={{width: '25px'}}>Perdas por Falecimento</TableCell>
                  <TableCell className={classes.fontReport} style={{width: '25px'}}>Perdas por Pequeno Valor / Prescrição</TableCell>
                  <TableCell className={classes.fontReport} style={{width: '25px'}}>Dívida Em Aberto</TableCell>
                </TableRow>
              </TableHead>
              {dividasEmAberto.map((divida) => {
                  if (divida !== undefined) {
                    totalSaldoAnteriorDivida = totalSaldoAnteriorDivida + divida.saldoAnteriorDivida;
                    totalValorDividaMes = totalValorDividaMes + divida.valorDividaMes;
                    totalValorPagamentoMes = totalValorPagamentoMes + divida.valorPagamentoMes;
                    totalPerdasPorFalecimento = totalPerdasPorFalecimento + divida.perdasPorFalecimento;
                    totalPerdasPorPequenoValor = totalPerdasPorPequenoValor + divida.perdasPorPequenoValor;
                    totalDividaEmAberto = totalDividaEmAberto + divida.dividaEmAberto;
                  }
                })
              }
              <TableBody>
                <TableRow>
                  <TableCell className={classes.fontReport}>{new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(totalSaldoAnteriorDivida)}</TableCell>
                  <TableCell className={classes.fontReport}>{new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(totalValorDividaMes)}</TableCell>
                  <TableCell className={classes.fontReport}>{new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(totalValorPagamentoMes)}</TableCell>
                  <TableCell className={classes.fontReport}>{new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(totalPerdasPorFalecimento)}</TableCell>
                  <TableCell className={classes.fontReport}>{new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(totalPerdasPorPequenoValor)}</TableCell>
                  <TableCell className={classes.fontReport}>{new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(totalDividaEmAberto)}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          : <Paper className={classes.rootNoRegs} elevation={1}>
            <Typography className={classes.centro} component='p'>
              Não foram encontrados registros de Dívidas em Aberto para este filtro.
            </Typography>
          </Paper>}
      </Paper>
    );
  }
}

class PrintComponentDividasEmAberto extends React.Component {
  render () {
    const { classes, dividasEmAberto, dataRef, dataFim, porPeriodo } = this.props;
    return (
      <div>
        <ReactToPrint
          trigger={() =>
            <div className={classes.div}>
              <Button
                variant='contained'
                color='primary'
                className={classes.button}
                href='#'>
                <Print className={classes.icon} /> Imprimir / Salvar
              </Button>
            </div>}
          content={() => this.componentRef}
        />
        <ComponentToPrint
          ref={el => (this.componentRef = el)}
          dividasEmAberto={dividasEmAberto}
          resumido={this.props.resumido}
          dataRef={dataRef}
          dataFim={dataFim}
          classes={classes}
          porPeriodo={porPeriodo} />
      </div>
    );
  }
}
export default withStyles(styles)(PrintComponentDividasEmAberto);
